import { FormSchemaAwareWidget } from '~/components/form';
import { TextArea } from 'semantic-ui-react';
import { InvestorFeedbackSelection } from '~/constants/project-investor-feedback';
import { useForm } from '~/hooks';

interface BidFeedbackNotesFormState {
  feedbackNotes: string;
  feedbackSelection: typeof InvestorFeedbackSelection[keyof typeof InvestorFeedbackSelection][];
}

export default function BidFeedbackNotes() {
  const { formState } = useForm<BidFeedbackNotesFormState>();
  
  const errorText = formState?.feedbackSelection.includes(InvestorFeedbackSelection.OTHER) && !formState.feedbackNotes ? 'Additional information is required for this selection.' : '';
  const placeholderText = 'Please let us know any other factors that make this opportunity a less-than-great fit for your organization.';
  
  return (
    <FormSchemaAwareWidget
      schemaKey='feedbackNotes'
      as={TextArea}
      placeholder={placeholderText}
      errorText={errorText}
    />
  );
}

